import { environment } from '../../../environments/environment';

/**
 * Load the Sales Portal analytics tracker for this build.
 *
 * The address comes from `environment.salesTrackerUrl`, so each build talks to
 * its own portal: beta -> sales-beta.neotrader.in, production ->
 * sales.neotrader.in, local -> localhost:8010. The tracker sends events back to
 * the portal it was loaded from.
 *
 * It runs alongside the Abacus tracker in index.html (the portal tracker uses
 * its own `window.NTSalesTracker` name), so both receive every event while the
 * portal is being tested. Remove whichever one is no longer needed afterwards.
 *
 * Never breaks the app: an empty URL skips it, and a failed load only logs.
 */
export function loadSalesTracker(): void {
  const src = environment.salesTrackerUrl;
  if (!src || typeof document === 'undefined') return;
  if (document.querySelector('script[data-nt-sales-tracker]')) return; // already added

  const script = document.createElement('script');
  script.src = src;
  script.async = true;
  script.setAttribute('data-nt-sales-tracker', '');
  script.onerror = () => console.warn('Sales Portal tracker could not be loaded from', src);
  document.head.appendChild(script);
}
